// Banner Images

const bannerTextAreaBlock = (): void => {
  const blocks = document.querySelectorAll<HTMLElement>('.banner-textarea');

  blocks.forEach((block) => {
    const bannerColumn: Element = block.querySelector(
      '.banner-textarea__banner'
    );

    const bannerSize = (): void => {
      if (block.classList.contains('banner-textarea--order-default')) {
        const bannerOffset = bannerColumn.getBoundingClientRect(),
          bannerEnd = bannerOffset.right,
          bannerWidth = 0 + bannerEnd;

        bannerColumn.setAttribute(
          'style',
          '--banner-width: ' + bannerWidth + 'px;'
        );
      } else {
        const bannerOffset = bannerColumn.getBoundingClientRect(),
          bannerEnd = bannerOffset.left,
          blockWidth = block.offsetWidth,
          bannerWidth = blockWidth - bannerEnd;

        bannerColumn.setAttribute(
          'style',
          '--banner-width: ' + bannerWidth + 'px;'
        );
      }
    };

    bannerSize();
  });
};

// splitHeaderImage

const splitHeaderImage = (): void => {
  const header = document.querySelector<HTMLElement>('.header--style-split');
  if (header) {
    const headerImageCol: Element = header.querySelector('.col--image');
    const setHeaderImageWidth = (): void => {
      const headerImageOffset = headerImageCol.getBoundingClientRect(),
        headerImageColStart = headerImageOffset.left,
        headerWidth = header.offsetWidth,
        headerImageWidth = headerWidth - headerImageColStart;
      headerImageCol.setAttribute(
        'style',
        '--header-image-width: ' + headerImageWidth + 'px;'
      );
    };
    setHeaderImageWidth();
  }
};

const init: () => void = () => {
  bannerTextAreaBlock();
  splitHeaderImage();
  const onresize = (): void => {
    bannerTextAreaBlock();
    splitHeaderImage();
  };
  window.addEventListener('resize', onresize);
};

init();

export default bannerTextAreaBlock;
